import { useState } from "react";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";
import Error from "../../Common/Error";
import LoadingButton from "../../Common/LoadingButton";
import { TDialog, TDialogTitle, TDialogForm, TDialogActions } from "../../Common/TDialog";

const ActivateAccountVerifyDialog = (props) => {
    const [verificationCode, setVerificationCode] = useState(props.verificationCode);

    const checkValidity = () => {
        return !!verificationCode;
    };

    const handleChangeCode = (e) => {
        setVerificationCode(e.target.value);
    };

    const handleCancelClick = () => {
        props.onCancel?.();
    };

    const handleVerifyClick = () => {
        props.onVerify?.(verificationCode);
    };

    return (
        <TDialog open={props.open}>
            <TDialogTitle>Activate account</TDialogTitle>

            <TDialogForm>
                {props.error && (
                    <FormControl>
                        <Error message={props.error} />
                    </FormControl>
                )}

                <TextField
                    label="Code"
                    value={verificationCode ?? ""}
                    required
                    fullWidth
                    helperText="Verification code sent via email"
                    onChange={handleChangeCode}
                />
            </TDialogForm>

            <TDialogActions>
                <Button color="primary" disabled={props.saving} onClick={handleCancelClick}>
                    Cancel
                </Button>

                <LoadingButton
                    color="primary"
                    disabled={!checkValidity()}
                    loading={props.saving}
                    onClick={handleVerifyClick}
                >
                    Verify
                </LoadingButton>
            </TDialogActions>
        </TDialog>
    );
};

ActivateAccountVerifyDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    saving: PropTypes.bool,
    error: PropTypes.string,
    onVerify: PropTypes.func,
    onCancel: PropTypes.func,
    verificationCode: PropTypes.string,
};

ActivateAccountVerifyDialog.defaultProps = {
    saving: false,
};

export default ActivateAccountVerifyDialog;
